(function () {
  function initTestimonialsCarousel(root) {
  var viewport = root.querySelector('[data-testimonials-viewport]');
  var dotsWrap = root.querySelector('[data-testimonials-dots]');
  if (!viewport) return;

  var slides = root.querySelectorAll('[data-testimonials-slide]');
  var dots = dotsWrap ? dotsWrap.querySelectorAll('[data-testimonials-dot]') : [];

  if (!slides.length) return;

  var activeIndex = 0;
  var scrollTimeout = null;

  function setActiveDot(index) {
  if (!dots.length) return;
  dots.forEach(function (dot, i) {
  dot.classList.toggle('is-active', i === index);
  });
  }

  function setActiveSlide(index) {
  slides.forEach(function (slide, i) {
  slide.classList.toggle('is-active', i === index);
  });
  }

  function goToSlide(index, behavior) {
  var slide = slides[index];
  if (!slide) return;
  viewport.scrollTo({
  left: slide.offsetLeft - (viewport.clientWidth - slide.clientWidth) / 2,
  behavior: behavior || 'smooth'
  });
  }

  var isDesktop = window.matchMedia('(min-width: 750px)').matches;
  if (isDesktop && slides.length > 2) {
  activeIndex = 1;
  }

  setActiveDot(activeIndex);
  setActiveSlide(activeIndex);

  viewport.addEventListener(
  'scroll',
  function () {
  if (scrollTimeout) window.clearTimeout(scrollTimeout);
  scrollTimeout = window.setTimeout(function () {
  var center = viewport.scrollLeft + viewport.clientWidth / 2;
  var closestIndex = 0;
  var closestDistance = Infinity;
  slides.forEach(function (slide, i) {
  var slideCenter = slide.offsetLeft + slide.clientWidth / 2;
  var distance = Math.abs(slideCenter - center);
  if (distance < closestDistance) {
  closestDistance = distance;
  closestIndex = i;
  }
  });
  if (closestIndex !== activeIndex) {
  activeIndex = closestIndex;
  setActiveDot(activeIndex);
  setActiveSlide(activeIndex);
  }
  }, 100);
  },
  { passive: true }
  );

  dots.forEach(function (dot, i) {
  dot.addEventListener('click', function () {
  activeIndex = i;
  setActiveDot(i);
  setActiveSlide(i);
  goToSlide(i);
  });
  });

  var autoplayDelay = 2500;
  var autoplayTimer = null;

  function stopAutoplay() {
  if (autoplayTimer) {
  window.clearInterval(autoplayTimer);
  autoplayTimer = null;
  }
  }

  function startAutoplay() {
  if (slides.length < 2) return;
  stopAutoplay();
  autoplayTimer = window.setInterval(function () {
  var nextIndex = (activeIndex + 1) % slides.length;
  activeIndex = nextIndex;
  setActiveDot(nextIndex);
  setActiveSlide(nextIndex);
  goToSlide(nextIndex);
  }, autoplayDelay);
  }

  viewport.addEventListener('mouseenter', stopAutoplay);
  viewport.addEventListener('mouseleave', startAutoplay);
  viewport.addEventListener('touchstart', stopAutoplay, { passive: true });

  startAutoplay();

  window.addEventListener('resize', function () {
  goToSlide(activeIndex, 'auto');
  });
  }

  function init() {
  document.querySelectorAll('.testimonials-carousel').forEach(initTestimonialsCarousel);
  }

  if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
  } else {
  init();
  }

  document.addEventListener('shopify:section:load', function (event) {
  var section = event.target.querySelector('.testimonials-carousel');
  if (section) initTestimonialsCarousel(section);
  });
  })();